import type { AxiosError } from "axios";

import { Logger } from "@framework/shared/bin/processes/logger.js";

const log = Logger.get("REST-API-COMMON");

export function handleError(error: any, throwMsg?: string): never {
	let reason: string | undefined;
	if (error.isAxiosError) {
		const ae: AxiosError = error;
		let body: any;
		if (ae.response) {
			body = ae.response.data;
			reason = body.error;
		}
		const baseUrl = ae.config?.baseURL || "http://missing";
		const path = ae.config?.url || "/missing/path";
		log.warn("fail calling service", {
			url: new URL(path, baseUrl).toString(),
			// url: buildFullPath(ae.config?.baseURL, ae.config?.url),
			status: ae.code,
			error: ae.message,
			reason: reason,
		});
		if (!reason) reason = ae.message;
	}
	if (throwMsg) {
		throw new Error(`${throwMsg}${reason ? `: ${reason}` : ""}`);
	}
	if (reason) {
		throw new Error(reason);
	}
	throw error;
}
